<template>
  <main style="position: relative">
    <article v-if="firstName" class="loggedInUserBanner">
      <h4>Logged in as: {{ firstName }} {{ lastName }}</h4>
      <h4>License: {{ getLicenseName }}</h4>
    </article>
    <div class="activity-id-label">
      <article class="errorAlert" v-if="errorMessage">
        <button class="errorAlertXButton" @click="errorMessage = ''">X</button>
        <span style="font-weight: bold">Error: </span>
        {{ errorMessage }}
      </article>
      <p>Activity ID</p>
      <input type="text" name="activity-id" class="activity-id" v-model="activityId" />
      <button v-on:click.prevent="launchByActivityId()" class="activity-id-go" tabindex="0">
        GO
      </button>
    </div>
    <div class="activity-variants">
      <h2>Activity Variants</h2>
      <ul>
        <li
          v-for="item in kwtActivities"
          :key="item.variant"
          v-on:click.prevent="launchByActivityTypeVariant(item.variant)"
          class="newJson"
        >
          <button>
            {{ item.displayName }}
            <span>{{ item.variant }}</span>
          </button>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import sortBy from 'lodash/sortBy';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import MetaHelper from 'src/mixins/MetaHelper';
import { activityTypeVariantData } from 'utils/activity-type-variant-util';

export default {
  mixins: [MetaHelper],
  mounted() {
    this.$nextTick(() => {
      this.setToolbarMode('fullScreenOnly');
      this.setKwtMode('tester');
      this.resetActivityStore();
      this.resetKeyboard();
    });
  },

  data() {
    return {
      activityId: '',
      errorMessage: ''
    };
  },

  computed: {
    ...mapState('activity', {
      activityData: 'data'
    }),
    ...mapState('student', {
      firstName: ({ firstName }) => firstName,
      lastName: ({ lastName }) => lastName
    }),
    ...mapGetters('activity', ['activityTitle']),

    kwtActivities() {
      return sortBy(activityTypeVariantData, 'displayName');
    },

    getLicenseName() {
      return this.getCurriculumName();
    }
  },

  methods: {
    ...mapMutations('application', ['setToolbarMode', 'setKwtMode']),
    ...mapActions('activity', ['fetchActivityData', 'fetchRandomDataForActivityTypeVariant']),

    ...mapMutations('activity', ['resetActivityStore']),
    ...mapMutations('keyboard', ['resetKeyboard']),

    async launchByActivityTypeVariant(variant) {
      const activity = await this.fetchRandomDataForActivityTypeVariant(variant);
      if (!activity) {
        this.errorMessage = `No activity found for: ${variant}. This could be due to this activity not existing for ${this.getLicenseName}.`;
        return;
      }
      this.launchActivity();
    },
    async launchByActivityId() {
      if (!this.activityId) return;

      const activity = await this.fetchActivityData({ activityId: this.activityId });
      if (!activity) {
        this.errorMessage = `No activity found with ID: ${this.activityId}. This could be due to this activity not existing for ${this.getLicenseName}.`;
        return;
      }

      this.launchActivity();
    },
    launchActivity() {
      const { $router, $nextTick, activityTitle: { name } = {} } = this;
      $nextTick(() => $router.push({ path: `/activities/${name}` }));
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-family: 'hwtfutura-semibold';
  font-size: 15px;
  padding: 0;
  margin: 10px 0 0 0;
  text-transform: uppercase;
  & em {
    text-transform: none;
  }
}
.activity-id-label {
  text-align: center;
  padding: 10px 0 0 0;
  p {
    font-family: 'hwtfutura-bold';
    display: inline-block;
    margin-right: 5px;
    color: black;
  }
}
.activity-id {
  font-family: 'hwtfutura-bold';
  text-align: center;
  font-size: 16px;
  width: 100px;
  display: inline-block;
  border: 2px solid black;
  border-radius: 5px;
  height: 30px;
  padding: 0;
  line-height: 30px;
}
.activity-id-go {
  display: inline-block;
  border: none;
  margin-left: 5px;
  font-size: 18px;
  font-family: 'hwtfutura-bold';
  border-radius: 5px;
  height: 30px;
  line-height: 30px;
  background-color: black;
  color: white;
}
.activity-variants {
  margin: 15px auto 0 auto;
  width: 980px;
  // height: 700px;
  // overflow-y: scroll;
  ul {
    list-style: none;
    margin: 0;
    padding: 8px 0 12px;
    text-align: center;
    border-top: 1px solid #ccc;
    li {
      display: inline-block;
      margin: 2px;
      padding: 0;
      vertical-align: top;
      button {
        font-family: 'hwtprint-bold';
        border: none;
        height: 50px;
        vertical-align: top;
        padding: 0px 10px;
        font-size: 15px;
        border-radius: 5px;
        background-color: #95c88a;
        &.qa {
          background-color: #ff8a00;
        }
        &.qa:hover {
          background-color: #ff9c00;
        }
        &.dev {
          background-color: #ff0066;
        }
        &.dev:hover {
          background-color: #ff0000;
        }
        &:hover {
          background-color: #8de279;
        }
        &.disabled {
          opacity: 0.65;
          cursor: not-allowed;
          background-color: #ccc;
        }
        span {
          display: block;
          font-size: 12px;
          line-height: 10px;
          font-family: 'hwtfutura';
        }
      }
      &.newJson button {
        background: #f1da36; /* Old browsers */
        background: linear-gradient(to bottom, #f1da36 0%, #fefcea 120%);
      }
    }
  }
}
.loggedInUserBanner {
  background: #d1ecf1;
  border: 4px solid #aadce5;
  border-radius: 0.5rem;
  left: 0.5rem;
  position: absolute;
  top: 0.5rem;

  h4:nth-child(1) {
    margin: 0.5rem 1rem 0px 1rem;
  }
  h4:nth-child(2) {
    margin: 0px 1rem 0.5rem 1rem;
  }
}
.errorAlert {
  display: relative;
  position: absolute;
  top: 60px;
  left: 30%;
  background: #f1a829;
  border: 4px solid #f57e07;
  border-radius: 0.5rem;
  padding: 60px;
  width: 300px;
}
.errorAlertXButton {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: transparent;
  border: none;
  font-weight: bold;
  font-size: 16px;
}
</style>
